import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  connect() {
    console.log('Tabs controller connected')
    const activeTab =
      this.tabTargets.find((t) => t.dataset.tabsActive === 'true') ||
      this.tabTargets[0]
    if (activeTab) this.activate(activeTab)
  }

  show(event) {
    event.preventDefault()
    this.activate(event.currentTarget)
  }

  activate(tab) {
    const panelId = tab.dataset.tabsPanel
    console.log(`Activating tab: ${tab.id}, panel: ${panelId}`)

    this.tabTargets.forEach((t) => {
      const active = t === tab
      t.dataset.tabsActive = active
      t.setAttribute('aria-selected', active)
      t.classList.toggle('border-b-2', active)
      t.classList.toggle('border-intoo-blue-medium', active)
      t.classList.toggle('text-intoo-blue-medium', active)
      t.classList.toggle('font-semibold', active)
      t.classList.toggle('text-gray-500', !active)
    })

    this.panelTargets.forEach((p) => {
      p.classList.toggle('tw-hidden', p.id !== panelId)
    })
  }
}
